import Profile from './Profile/Profile'


const Settings = () => {
  return <>
    <Profile />
    
  </>
}

export default Settings
